import { extendTheme } from "native-base";

export const nativeBaseTheme = (colorMode: string = 'light') => extendTheme({
    colors: {
        // Modern elegant color palette
        primary: {
            50: '#f8fafc',
            100: '#f1f5f9',
            200: '#e2e8f0',
            300: '#cbd5e1',
            400: '#94a3b8',
            500: '#64748b',
            600: '#1e293b',
            700: '#334155',
            800: '#1e293b',
            900: '#0f172a',
        },
        // Accent color for desktop highlights
        accent: {
            50: '#eff6ff',
            100: '#dbeafe',
            200: '#bfdbfe',
            300: '#93c5fd',
            400: '#60a5fa',
            500: '#3b82f6',
            600: '#2563eb',
            700: '#1d4ed8',
            800: '#1e40af',
            900: '#1e3a8a',
        },
        // Success, warning, error colors
        success: {
            500: '#22c55e',
            600: '#16a34a',
        },
        warning: {
            500: '#f59e0b',
            600: '#d97706',
        },
        error: {
            500: '#ef4444',
            600: '#dc2626',
        }
    },
    config: {
        initialColorMode: colorMode,
    },
    components: {
        Box: {
            variants: {
                main: () => {
                    return {
                        bg: colorMode === 'light' ? 'primary.50' : 'primary.900',
                    };
                }
            }
        },
        Button: {
            defaultProps: {
                // Keep default black for brand consistency
            },
            baseStyle: {
                borderRadius: 'lg',
                _text: {
                    fontWeight: '600',
                }
            },
        },
        Select: {
            baseStyle: {
              fontSize: 14,
              borderRadius: 'lg',
            },
        },
        Input: {
            baseStyle: {
                borderRadius: 'lg',
            }
        },
        Card: {
            baseStyle: {
                borderRadius: 'xl',
                shadow: colorMode === 'light' ? '2' : '0',
            }
        }
    }
});